// @refresh reload
import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { Suspense } from "solid-js";
import "./styles/global.scss";
import { I18nProvider } from "./i18n/i18n";

export default function App() {
  return (
    <Router
      root={props => (
        <Suspense>
          <I18nProvider>
            {props.children}
          </I18nProvider>
        </Suspense>
      )}
    >
      <FileRoutes />
    </Router>
  );
}
